import { useEffect, useState } from 'react';
import { notification } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
//import { getSingleSchool } from "../../services/learnService";

import Place from '../../assets/icons/Place';
import SchoolSubjectCard from '../../components/LearnSubjectCard/SchoolSubjectCard';
import Carousel from 'react-multi-carousel';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import Button from '../../components/Button/Button';
import Cart from '../../assets/icons/Cart';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import { baseURL } from '../../utils/axios';

const DashboardSingleSchool = () => {
  let sCart = JSON.parse(localStorage.getItem('cart'));

  console.log(school);

  const { id } = useParams();
  const navigate = useNavigate();
  const [school, setSchool] = useState([]);
  const [loading, setLoading] = useState(false);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      paritialVisibilityGutter: 60,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      paritialVisibilityGutter: 60,
    },
  };

  useEffect(() => {
    let token = localStorage.getItem('token');
    const getSchool = async () => {
      setLoading(true);

      const res = await fetch(`${baseURL}/schools/${id}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const data = await res.json();

      if (res.status === 200) {
        setSchool(data.data.school);
      }
      setLoading(false);
      if (res.status === 401) {
        notification['error']({
          message: 'Session expired, please log in again',
        });
        navigate('/login');
      }
      setLoading(false);
    };
    getSchool();
  }, []);

  let provider = window.location.pathname.includes('tutor')
    ? 'topics'
    : 'subjects';

  return (
    <div>
      {' '}
      {loading ? (
        <p>Please wait</p>
      ) : (
        <>
          <DashboardHeader />
          <div className='single-subject'>
            <div
              className='single-subject__hero'
              style={{
                backgroundImage: `url(${
                  school?.banner ? school?.banner : school.logo
                })`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
              }}
            >
              <div className='single-subject__hero__breadcrumbs'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
                    fill='white'
                  />
                </svg>
                <p>
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.history.back()}
                  >
                    Home{' '}
                  </span>
                  | {school?.name}
                </p>
              </div>
            </div>
            <div className='single-subject__hero__info'>
              <div className='single-subject__hero__info__logo'>
                <img src={school?.logo} alt='' />
              </div>

              <div className='single-subject__hero__info__details'>
                <h2>{school?.name}</h2>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <Place /> <p>{`${school?.state},${school?.country}`}</p>
                </div>
                <p>{school?.bio}</p>
              </div>
            </div>

            <div className='dashboard-body'>
              <div
                className='recommended-section__title'
                style={{ marginBottom: '40px' }}
              >
                <h2 style={{ textTransform: 'capitalize' }}>
                  {provider} offered
                </h2>
                <p>
                  These are {provider} specific to your class being offered by{' '}
                  {school?.name}
                </p>
              </div>

              <Carousel
                responsive={responsive}
                showDots={true}
                itemClass={`carouselItem`}
              >
                {school?.courses === undefined ? (
                  <div></div>
                ) : (
                  school?.courses?.map((el, index) => (
                    <SchoolSubjectCard
                      key={el.id}
                      schoolHeader={
                        school?.id === 12
                          ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1680096219/WhatsApp_Image_2023-03-29_at_13.50.08_hqqdcv.jpg'
                          : el?.title?.toLowerCase()?.includes('biology')
                          ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833246/4_ywa1uq.jpg'
                          : el?.title?.toLowerCase()?.includes('mathematics')
                          ? 'https://leverageedu.com/blog/wp-content/uploads/2020/07/Branches-of-Mathematics.png'
                          : el?.title?.toLowerCase()?.includes('english')
                          ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrP9mK3dTuXB86woJ2JW7J8TkxszYhRVk_4Q&usqp=CAU'
                          : el.title?.toLowerCase().includes('food')
                          ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1680783147/food_and_nutrition_lqxah9.png'
                          : el.title?.toLowerCase().includes('economics')
                          ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833433/9_eknlh0.jpg'
                          : el.title?.toLowerCase().includes('technical')
                          ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833564/3_tzp8za.jpg'
                          : el.banner
                      }
                      index={index}
                      subject={el.name}
                      description={el.description || 'No description available'}
                      topic={el.title}
                      id={el.id}
                      duration={el.duration}
                      lessonStyle={el.lesson_style}
                      lessonCount={el.topics_count}
                      studentCount={el.students_count}
                      currency={el.currency.symbol}
                      subjectClass={el.subject_class.title}
                      selectSchool={() => {
                        navigate(`/learn/${el.id}/${id}`);
                      }}
                      page='dashboard'
                    />
                  ))
                )}
              </Carousel>
            </div>
          </div>
        </>
      )}
      <div className='texture-bg'>
        <div className='cta'>
          <div className='cta__left'>
            <h1>
              Your academic subject weakness can become an area of strength
            </h1>
            <p>
              Be the first to know when we go live, register on PL by Edves and{' '}
              <br /> become academic stars
            </p>
          </div>
          <div className='cta__right'>
            <Button className='secondary-button' text='Be The First To Know' />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DashboardSingleSchool;
